import { FC } from 'react';
import { Card, Descriptions, Empty, Row, Col } from 'antd';
import { InsuranceInfo } from '../../../../../models/admin/student-admin.model';

interface InsuranceTabProps {
  insurance: InsuranceInfo | null;
}

const InsuranceTab: FC<InsuranceTabProps> = ({ insurance }) => {
  if (!insurance) {
    return (
      <Card title="Insurance & Pediatrician Information">
        <Empty description="No insurance information on file" />
      </Card>
    );
  }

  return (
    <Row gutter={16}>
      <Col xs={24} lg={12}>
        <Card title="Insurance Information" style={{ marginBottom: 16 }}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Insurance Company">
              {insurance.insuranceCompany || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {insurance.insurancePhone || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Policy Number">
              {insurance.insurancePolicyNumber || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Group Number">
              {insurance.insuranceGroupNumber || '-'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>

      <Col xs={24} lg={12}>
        <Card title="Pediatrician" style={{ marginBottom: 16 }}>
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Name">
              {insurance.pediatricianName || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {insurance.pediatricianPhone || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Address">
              {insurance.pediatricianAddress || '-'}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        <Card title="Dentist">
          <Descriptions column={1} bordered size="small">
            <Descriptions.Item label="Name">
              {insurance.dentalName || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Phone">
              {insurance.dentalPhone || '-'}
            </Descriptions.Item>
            <Descriptions.Item label="Address">
              {insurance.dentalAddress || '-'}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Col>
    </Row>
  );
};

export default InsuranceTab;
